import React, { useEffect, useState } from 'react';
import { setToken, requestData, updateData } from '../services/request';
import { useLocation } from 'react-router-dom';
import './OrderDetails.css';
import ActionButton from '../components/ActionButton/ActionButton';

function OrderDetails() {
  const [list, setList] = useState([]);
  const [order, setOrder] = useState({});
  const [confirmed, setConfirmed] = useState(false);
  const [canceled, setCanceled] = useState(false);
  const location = useLocation();
  const pathname = location.pathname.split('/')[2];
  const [comment, setComment] = useState('');
  const [status, setStatus] = useState("");

  const getLoginData = () => {
    const data = JSON.parse(sessionStorage.getItem('login'));
    if (data) {
      const { user, token } = data;
      return { user, token };
    } else {
      return {};
    }
  };

  const recoveryData = async () => {
    const token = getLoginData().token;
    setToken(token);
    const result = await requestData(`/orders/${pathname}`);
    setOrder(result);
    setList(result._products);
    setStatus(result._status);
  };

  useEffect(() => {
    recoveryData();
  }, []);

  const askHelp = async () => {
    const user = getLoginData().user;
    const text = `Olá, me chamo ${user.name} e necessito de ajudar com o pedido de ID: ${pathname}`;
    window.open(`https://wa.me/5587996420559/?text=${text}`, '_blank');
  };

  const redirectToWhatsapp = async () => {
    const user = getLoginData().user;
    const text = `Olá, me chamo ${user.name} e gostaria de finalizar o meu pedido com ID: ${order._id} e valor total de R$ ${order._value.toFixed(2).replace('.', ',')}`;
    window.open(`https://wa.me/5587996420559/?text=${text}`, '_blank');
  };

  const sellProducts = async () => {
    const newOrder = order;
    const newProducts = newOrder._products.map((e) => {
      e.size = {
        nb: e.size.rn || 0,
        s: e.size.p || 0,
        m: e.size.m || 0,
        b: e.size.g || 0,
        oneYear: e.size['1'] || 0,
        twoYear: e.size['2'] || 0,
        un: e.size.un || 0,
      }
      return e;
    })
    newOrder._products = newProducts;
    await Promise.all(newOrder._products.map((e) => {
      const token = getLoginData().token
      setToken(token);
      updateData('/clothes', e);
    }));
  };

  const cancelOrder = async () => {
    let payload = {
      comments: comment,
      status: "pedido cancelado",
    }
    await updateData(`/orders/${order._id}`, payload);
    setCanceled(true);
    setConfirmed(true);
    setStatus('pedido cancelado')
  };

  const updateOrder = async (name, value) => {
    console.log(name)
    const payload = { status: value }
    switch (name) {
      case 'confirm':
        sellProducts();
        setToken(getLoginData().token);
        await updateData(`/orders/${order._id}`, payload);
        setConfirmed(true);
        break;
      case 'cancel':
        if (comment) {
          cancelOrder();
        } else {
          alert('Você precisa informar um motivo para cancelar o pedido');
        }
        break;
      case 'analysis':
      default:
        setToken(getLoginData().token);
        await updateData(`/orders/${order._id}`, payload);
        setStatus(value);
        break;
    }
  };

  const handleChange = ({target}) => {
    const {name, value} = target;
    switch (name) {      
      case 'comment':
        setComment(value);
        break;
    
      default:
        break;
    }
  }

const updateCommit = async () => {
  setToken(getLoginData().token);
  const userName = JSON.parse(sessionStorage.getItem('login')).user.name;
  const message = `[${userName}]: ${comment}`
  await updateData(`/orders/${order._id}`, { comments: message });
  recoveryData();
};

useEffect(() => {
  if (confirmed) {
    recoveryData();
    console.log('print');
  }
}, [confirmed]);

return (
  <main className="page-container">
    {
      location.pathname.includes('pedido') ? <h2>Pedido: {order._id}</h2> : <h2>Meu carrinho</h2>
    }
    {
      list && list.length > 0 ? (
        <section className="order-container">
          {
            list.map((e) =>
              <article className="cart-item" key={`${e.ref}`}>
                <img
                  src={e.thumbs}
                  alt={`product-id-${e.ref}`}
                  className="product-card-image"
                />
                <div className="cart-item-data">
                  <h4 className="cart-title">{e.name}</h4>
                  <p>referência do produto: {e.ref}</p>
                  <p>tamanhos selecionados:</p>
                  {
                    Object.entries(e.size).map((s) =>
                      <p key={`${e.ref}-${s[0]}`}>{`${s[0]}: ${s[1]}`}</p>)
                  }
                  <p>{`preço unitário: R$ ${e.cashPrice}`.replace('.', ',')}</p>
                  <p>{`total à vista: R$ ${e.cashTotal}`.replace('.', ',')}</p>
                  <p>{`4x de R$ ${e.parcel}`.replace('.', ',')}</p>
                </div>
              </article>)
          }
          <section className="customer-controllers">
            <p>
              Total do pedido: R$ {' '}
              {
                list.reduce((acc, curr) => {
                  return acc + curr.cashTotal;
                }, 0).toFixed(2).replace('.', ',')
              }
            </p>
            <p>Status do pedido: {status}</p>
            {
              order._comments ? <p>Comentário: {order._comments}</p> : null
            }
            <ActionButton
              type="button"
              buttonText="Realizar pagamento"
              buttonType="action"
              functionOnClick={redirectToWhatsapp}
            />
            <ActionButton
              type="button"
              buttonText="Entrar em contato"
              buttonType="action"
              functionOnClick={askHelp}
            />
          </section>
          {
            getLoginData().user && (getLoginData().user.role === 'seller' || getLoginData().user.role === 'admin') ? (
              <section className="employee-controllers">
                <ActionButton
                  type="button"
                  name="confirm"
                  value="pagamento confirmado"
                  buttonText="Confirmar Pagamento"
                  buttonType="action"
                  functionOnClick={() => updateOrder("confirm", "pagamento confirmado")}
                  disabled={
                    status === 'pagamento confirmado'
                    || status === 'pedido cancelado'
                    || status === 'pedido entregue'
                  }
                />
                <ActionButton
                  type="button"
                  name="analysis"
                  value="aguardando resposta do cliente"
                  buttonText="Solicitar resposta"
                  buttonType="action"
                  functionOnClick={() => updateOrder("analysis", "aguardando resposta do cliente")}
                  disabled={
                    status === 'pedido cancelado'
                    || status === 'pedido entregue'
                  }
                />
                <ActionButton
                  type="button"
                  name="finish"
                  value="pedido entregue"
                  buttonText="Finalizar pedido"
                  buttonType="action"
                  functionOnClick={() => updateOrder("finish", "pedido entregue")}
                  disabled={
                    status === 'pedido cancelado'
                    || status === 'pedido entregue'
                  }
                />
                <ActionButton
                  type="button"
                  name="cancel"
                  buttonText="Rejeitar pedido"
                  buttonType="action"
                  functionOnClick={() => updateOrder("cancel", "cancel")}
                  disabled={
                    status === 'pedido cancelado'
                    || status === 'pedido entregue'
                  }
                />
                  <ActionButton
                    type="button"
                  buttonText="Comentar"
                  buttonType="action"
                  functionOnClick={updateCommit}
                  />
                <div>
                  <textarea
                    type="text"
                    name="comment"
                    value={comment}
                    onChange={(e) => handleChange(e)}
                    className="order-comment-input"
                  />
                </div>
              </section>
            ) : null
          }
        </section>
      ) : <p>Carregando</p>
    }
  </main>
)
};

export default OrderDetails;
